/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Faceta API
 * API мультитенантного admin-движка Faceta. Спека генерируется из типов Go и является контрактом для фронтенда.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateMenuInputBody,
  ErrorModel,
  MenuBody,
  MenuUpdateHeaders,
  MenusOutputBody,
  UpdateMenuInputBody
} from '../model';

import { facetaFetch } from '../../http';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type menuDeleteResponse204 = {
  data: void
  status: 204
}

export type menuDeleteResponse401 = {
  data: ErrorModel
  status: 401
}

export type menuDeleteResponse403 = {
  data: ErrorModel
  status: 403
}

export type menuDeleteResponse404 = {
  data: ErrorModel
  status: 404
}

export type menuDeleteResponse422 = {
  data: ErrorModel
  status: 422
}

export type menuDeleteResponse500 = {
  data: ErrorModel
  status: 500
}

export type menuDeleteResponseSuccess = (menuDeleteResponse204) & {
  headers: Headers;
};
export type menuDeleteResponseError = (menuDeleteResponse401 | menuDeleteResponse403 | menuDeleteResponse404 | menuDeleteResponse422 | menuDeleteResponse500) & {
  headers: Headers;
};

export type menuDeleteResponse = (menuDeleteResponseSuccess | menuDeleteResponseError)

export const getMenuDeleteUrl = (menuId: string,) => {




  return `/menus/${menuId}`
}

/**
 * @summary Удалить меню
 */
export const menuDelete = async (menuId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<menuDeleteResponse> => {

  return facetaFetch<menuDeleteResponse>(getMenuDeleteUrl(menuId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getMenuDeleteQueryKey = (menuId: string,) => {
    return [
    'DELETE', `/menus/${menuId}`
    ] as const;
    }


export const getMenuDeleteQueryOptions = <TData = Awaited<ReturnType<typeof menuDelete>>, TError = ErrorModel>(menuId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof menuDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMenuDeleteQueryKey(menuId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof menuDelete>>> = ({ signal }) => menuDelete(menuId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: menuId !== null && menuId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof menuDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MenuDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof menuDelete>>>
export type MenuDeleteQueryError = ErrorModel


export function useMenuDelete<TData = Awaited<ReturnType<typeof menuDelete>>, TError = ErrorModel>(
 menuId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof menuDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof menuDelete>>,
          TError,
          Awaited<ReturnType<typeof menuDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMenuDelete<TData = Awaited<ReturnType<typeof menuDelete>>, TError = ErrorModel>(
 menuId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof menuDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof menuDelete>>,
          TError,
          Awaited<ReturnType<typeof menuDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMenuDelete<TData = Awaited<ReturnType<typeof menuDelete>>, TError = ErrorModel>(
 menuId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof menuDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Удалить меню
 */

export function useMenuDelete<TData = Awaited<ReturnType<typeof menuDelete>>, TError = ErrorModel>(
 menuId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof menuDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMenuDeleteQueryOptions(menuId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type menuUpdateResponse200 = {
  data: MenuBody
  status: 200
}

export type menuUpdateResponse401 = {
  data: ErrorModel
  status: 401
}

export type menuUpdateResponse403 = {
  data: ErrorModel
  status: 403
}

export type menuUpdateResponse404 = {
  data: ErrorModel
  status: 404
}

export type menuUpdateResponse409 = {
  data: ErrorModel
  status: 409
}

export type menuUpdateResponse412 = {
  data: ErrorModel
  status: 412
}

export type menuUpdateResponse422 = {
  data: ErrorModel
  status: 422
}

export type menuUpdateResponse428 = {
  data: ErrorModel
  status: 428
}

export type menuUpdateResponse500 = {
  data: ErrorModel
  status: 500
}

export type menuUpdateResponseSuccess = (menuUpdateResponse200) & {
  headers: Headers;
};
export type menuUpdateResponseError = (menuUpdateResponse401 | menuUpdateResponse403 | menuUpdateResponse404 | menuUpdateResponse409 | menuUpdateResponse412 | menuUpdateResponse422 | menuUpdateResponse428 | menuUpdateResponse500) & {
  headers: Headers;
};

export type menuUpdateResponse = (menuUpdateResponseSuccess | menuUpdateResponseError)

export const getMenuUpdateUrl = (menuId: string,) => {




  return `/menus/${menuId}`
}

/**
 * Пункты правит редактор — они сразу на сайте; ключ и название — тот, кто меняет устройство сайта.
 * @summary Изменить меню
 */
export const menuUpdate = async (menuId: string,
    updateMenuInputBody: NonReadonly<UpdateMenuInputBody>,
    headers: MenuUpdateHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<menuUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<menuUpdateResponse>(getMenuUpdateUrl(menuId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(updateMenuInputBody)
  }
);}





export const getMenuUpdateQueryKey = (menuId: string,
    updateMenuInputBody?: NonReadonly<UpdateMenuInputBody>,) => {
    return [
    'PATCH', `/menus/${menuId}`, updateMenuInputBody
    ] as const;
    }


export const getMenuUpdateQueryOptions = <TData = Awaited<ReturnType<typeof menuUpdate>>, TError = ErrorModel>(menuId: string,
    updateMenuInputBody: NonReadonly<UpdateMenuInputBody>,
    headers: MenuUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof menuUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMenuUpdateQueryKey(menuId,updateMenuInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof menuUpdate>>> = ({ signal }) => menuUpdate(menuId,updateMenuInputBody,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: menuId !== null && menuId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof menuUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MenuUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof menuUpdate>>>
export type MenuUpdateQueryError = ErrorModel


export function useMenuUpdate<TData = Awaited<ReturnType<typeof menuUpdate>>, TError = ErrorModel>(
 menuId: string,
    updateMenuInputBody: NonReadonly<UpdateMenuInputBody>,
    headers: MenuUpdateHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof menuUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof menuUpdate>>,
          TError,
          Awaited<ReturnType<typeof menuUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMenuUpdate<TData = Awaited<ReturnType<typeof menuUpdate>>, TError = ErrorModel>(
 menuId: string,
    updateMenuInputBody: NonReadonly<UpdateMenuInputBody>,
    headers: MenuUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof menuUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof menuUpdate>>,
          TError,
          Awaited<ReturnType<typeof menuUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMenuUpdate<TData = Awaited<ReturnType<typeof menuUpdate>>, TError = ErrorModel>(
 menuId: string,
    updateMenuInputBody: NonReadonly<UpdateMenuInputBody>,
    headers: MenuUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof menuUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Изменить меню
 */

export function useMenuUpdate<TData = Awaited<ReturnType<typeof menuUpdate>>, TError = ErrorModel>(
 menuId: string,
    updateMenuInputBody: NonReadonly<UpdateMenuInputBody>,
    headers: MenuUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof menuUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMenuUpdateQueryOptions(menuId,updateMenuInputBody,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type menusListResponse200 = {
  data: MenusOutputBody
  status: 200
}

export type menusListResponse401 = {
  data: ErrorModel
  status: 401
}

export type menusListResponse403 = {
  data: ErrorModel
  status: 403
}

export type menusListResponse404 = {
  data: ErrorModel
  status: 404
}

export type menusListResponse422 = {
  data: ErrorModel
  status: 422
}

export type menusListResponse500 = {
  data: ErrorModel
  status: 500
}

export type menusListResponseSuccess = (menusListResponse200) & {
  headers: Headers;
};
export type menusListResponseError = (menusListResponse401 | menusListResponse403 | menusListResponse404 | menusListResponse422 | menusListResponse500) & {
  headers: Headers;
};

export type menusListResponse = (menusListResponseSuccess | menusListResponseError)

export const getMenusListUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/menus`
}

/**
 * @summary Меню окружения
 */
export const menusList = async (id: string,
    kind: 'production' | 'development', options?: Parameters<typeof facetaFetch>[1]): Promise<menusListResponse> => {

  return facetaFetch<menusListResponse>(getMenusListUrl(id,kind),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMenusListQueryKey = (id: string,
    kind: 'production' | 'development',) => {
    return [
    `/sites/${id}/environments/${kind}/menus`
    ] as const;
    }


export const getMenusListQueryOptions = <TData = Awaited<ReturnType<typeof menusList>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof menusList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMenusListQueryKey(id,kind);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof menusList>>> = ({ signal }) => menusList(id,kind, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof menusList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MenusListQueryResult = NonNullable<Awaited<ReturnType<typeof menusList>>>
export type MenusListQueryError = ErrorModel


export function useMenusList<TData = Awaited<ReturnType<typeof menusList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof menusList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof menusList>>,
          TError,
          Awaited<ReturnType<typeof menusList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMenusList<TData = Awaited<ReturnType<typeof menusList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof menusList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof menusList>>,
          TError,
          Awaited<ReturnType<typeof menusList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMenusList<TData = Awaited<ReturnType<typeof menusList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof menusList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Меню окружения
 */

export function useMenusList<TData = Awaited<ReturnType<typeof menusList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof menusList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMenusListQueryOptions(id,kind,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type menuCreateResponse201 = {
  data: MenuBody
  status: 201
}

export type menuCreateResponse401 = {
  data: ErrorModel
  status: 401
}

export type menuCreateResponse403 = {
  data: ErrorModel
  status: 403
}

export type menuCreateResponse404 = {
  data: ErrorModel
  status: 404
}

export type menuCreateResponse409 = {
  data: ErrorModel
  status: 409
}

export type menuCreateResponse422 = {
  data: ErrorModel
  status: 422
}

export type menuCreateResponse500 = {
  data: ErrorModel
  status: 500
}

export type menuCreateResponseSuccess = (menuCreateResponse201) & {
  headers: Headers;
};
export type menuCreateResponseError = (menuCreateResponse401 | menuCreateResponse403 | menuCreateResponse404 | menuCreateResponse409 | menuCreateResponse422 | menuCreateResponse500) & {
  headers: Headers;
};

export type menuCreateResponse = (menuCreateResponseSuccess | menuCreateResponseError)

export const getMenuCreateUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/menus`
}

/**
 * Ключ один на окружение: второе «header» — 409.
 * @summary Завести меню
 */
export const menuCreate = async (id: string,
    kind: 'production' | 'development',
    createMenuInputBody: NonReadonly<CreateMenuInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<menuCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<menuCreateResponse>(getMenuCreateUrl(id,kind),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createMenuInputBody)
  }
);}





export const getMenuCreateQueryKey = (id: string,
    kind: 'production' | 'development',
    createMenuInputBody?: NonReadonly<CreateMenuInputBody>,) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/menus`, createMenuInputBody
    ] as const;
    }


export const getMenuCreateQueryOptions = <TData = Awaited<ReturnType<typeof menuCreate>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    createMenuInputBody: NonReadonly<CreateMenuInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof menuCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMenuCreateQueryKey(id,kind,createMenuInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof menuCreate>>> = ({ signal }) => menuCreate(id,kind,createMenuInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof menuCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MenuCreateQueryResult = NonNullable<Awaited<ReturnType<typeof menuCreate>>>
export type MenuCreateQueryError = ErrorModel


export function useMenuCreate<TData = Awaited<ReturnType<typeof menuCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    createMenuInputBody: NonReadonly<CreateMenuInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof menuCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof menuCreate>>,
          TError,
          Awaited<ReturnType<typeof menuCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMenuCreate<TData = Awaited<ReturnType<typeof menuCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    createMenuInputBody: NonReadonly<CreateMenuInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof menuCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof menuCreate>>,
          TError,
          Awaited<ReturnType<typeof menuCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMenuCreate<TData = Awaited<ReturnType<typeof menuCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    createMenuInputBody: NonReadonly<CreateMenuInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof menuCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Завести меню
 */

export function useMenuCreate<TData = Awaited<ReturnType<typeof menuCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    createMenuInputBody: NonReadonly<CreateMenuInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof menuCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMenuCreateQueryOptions(id,kind,createMenuInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






